/**
 * Repairs text where a null character (JSON \u0000) is immediately followed by
 * hex digits that were meant to form a single \uXXXX escape.
 * Example: patient\u000027s → patient's (intended \u0027 apostrophe).
 */
export function fixMalformedUnicodeText(text: string): string {
  if (!text) return text;

  return text
    .replace(/\u0000([0-9a-fA-F]{2,4})/g, (_, hex: string) => {
      const code = parseInt(hex.padStart(4, "0"), 16);
      if (code >= 0x20 && code <= 0x10ffff) {
        try {
          return String.fromCodePoint(code);
        } catch {
          return "";
        }
      }
      return "";
    })
    .replace(/\u0000/g, "")
    // Degree / ordinal / ring often substituted for ® after a letter.
    // Avoid temperatures (90°) and units (temp°C): require a letter before and
    // a non-letter (or end) after.
    .replace(/([A-Za-z])[\u00B0\u00BA\u02DA](?![A-Za-z])/g, "$1\u00AE");
}
